import Text from 'components/Text/Text';
import React, { useContext, useState, useEffect } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../../../dishAssignmentState/dishAssignmentContext';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './CancelAndSaveButtons.module.scss';

const CancelAndSaveButtons: React.FC = () => {
	const { changeTypeOfModalWindow, setVisibleAdditionalRestaurantsModal, IDsSelectedCategories, dishes } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);
	const [isActiveSaveBtn, setIsActiveSaveBtn] = useState<boolean>(true);

	useEffect(() => {
		const someSubcategoryChanged = dishes.some((el) => el.isChanged);
		setIsActiveSaveBtn(someSubcategoryChanged);
	}, [dishes]);

	return (
		<div className={style.container} data-test="CancelAndSaveButtons">
			<Button
				className={style.cancelBtn}
				theme="outlined"
				onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
				disabled={!Object.keys(IDsSelectedCategories).length}
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				}>
				<Text translationNameSpace="listing" translationKey="cancelButton" asFragment={true} />
			</Button>

			<Button
				className={style.saveBtn}
				theme="primaryBlue"
				onClick={() => setVisibleAdditionalRestaurantsModal(true)}
				disabled={!isActiveSaveBtn}>
				<Text translationNameSpace="listing" translationKey="saveButton" asFragment={true} />
			</Button>
		</div>
	);
};

export default CancelAndSaveButtons;
